import {Component, Input} from "@angular/core";
import {DbDateStruct} from "./date-struct";
import {DayViewModel, MonthViewModel} from "./datepicker-view.model";
import {DbDatepickerService} from "./datepicker.service";
import {DbDatepickerComponent} from "./datepicker";
import {DbDate} from "./db-date";

@Component({
    selector: 'db-datepicker-month',
    styleUrls: ['./datepicker-month.scss'],
    template: `
    <div *ngIf="viewModel.weekdays.length > 0" class="db-datepicker-week">
      <div *ngFor="let weekday of viewModel.weekdays" class="db-datepicker-weekday"><span>{{ weekday }}</span></div>
    </div>
    <ng-template ngFor let-week [ngForOf]="viewModel.weeks">
      <div *ngIf="!week.collapsed" class="db-datepicker-week">
        <div *ngFor="let day of week.days" (click)="doSelect(day); $event.preventDefault()" class="db-datepicker-day"
             [class.disabled]="day.context.disabled || day.hidden"
             [tabindex]="day.tabindex"
             [class.db-datepicker-today]="day.context.today"
             [class.first]="!isMuted(day) && isFirst(day.context.date)"
             [class.last]="!isMuted(day) && isLast(day.context.date)"
             [class.outside]="isMuted(day)"
             [class.range]="isInside(day.context.date)"
             [class.faded]="!isMuted(day) && isRange(day.context.date)"
             [class.today]="!isMuted(day) && !isRange(day.context.date) && !isInside(day.context.date) && day.context.today"
        >
          <span>
            {{day.context.date.day}}
          </span>
        </div>
      </div>
    </ng-template>
  `,
    standalone: false
})
export class DbDatepickerMonthComponent {

  @Input() startDate;
  @Input() endDate;
  @Input()
  set month(month: DbDateStruct) {
    this.viewModel = this._service.getMonth(month);
  }

  viewModel: MonthViewModel;

  constructor(
    public datepicker: DbDatepickerComponent,
    private _service: DbDatepickerService
  ) {}

  public doSelect(day: DayViewModel): void {
    if (!day.context.disabled && !day.hidden) {
      this.datepicker.onDateSelect(day.date);
    }
  }

  public isFirst(day: DbDate): boolean {
    return day.equals(this.startDate) && !!this.endDate;
  }

  public isLast(day: DbDate): boolean {
    return day.equals(this.endDate) && !!this.startDate;
  }

  public isMuted(day: DayViewModel): boolean {
    return !day.context || (day.context && (day.context.date && day.context.date.month !== day.context.currentMonth) || day.context.disabled) || day.hidden;
  }

  public isInside(date: DbDate): boolean {
    return this.endDate && date.after(this.startDate) && date.before(this.endDate);
  }

  public isRange(date: DbDate): boolean {
    return date.equals(this.startDate) || (this.endDate && date.equals(this.endDate));
  }
}
